import { z } from 'zod';
const passwordRules = z
    .string()
    .min(8, 'Must be at least 8 characters')
    .regex(/[A-Z]/, 'Must contain at least one uppercase letter')
    .regex(/[a-z]/, 'Must contain at least one lowercase letter')
    .regex(/[0-9]/, 'Must contain at least one number')
    .regex(/[^A-Za-z0-9]/, 'Must contain at least one special character');
// `org_slug` is optional so super admins can sign in without one. Org
// users still need it — the backend will 401 the slug-less attempt
// against the org login endpoint, and the LoginPage falls through to
// the super-admin endpoint at that point.
export const loginSchema = z.object({
    org_slug: z.string().trim().optional().default(''),
    email: z.string().trim().email('Please enter a valid email'),
    password: z.string().min(1, 'Password is required'),
});
export const registerOrgSchema = z.object({
    invite_code: z.string().trim().min(1, 'Invite code is required'),
    org_name: z.string().trim().min(1, 'Organization name is required'),
    org_slug: z
        .string()
        .trim()
        .min(3, 'Slug must be at least 3 characters')
        .max(40, 'Slug cannot exceed 40 characters')
        .regex(/^[a-z0-9-]+$/, 'Slug can only contain lowercase letters, numbers, and hyphens'),
    admin_email: z.string().trim().email('Please enter a valid email'),
    admin_password: passwordRules,
    admin_full_name: z.string().trim().min(1, 'Your full name is required'),
    admin_phone: z
        .string()
        .trim()
        .regex(/^[+\d][\d\s().-]{6,}$/, 'Please enter a valid phone number')
        .optional()
        .or(z.literal('')),
});
export const requestInviteSchema = z.object({
    email: z.string().trim().email('Please enter a valid email'),
});
export const forgotPasswordSchema = z.object({
    org_slug: z.string().trim().min(1, 'Organization is required'),
    email: z.string().trim().email('Please enter a valid email'),
});
export const resetPasswordSchema = z
    .object({
    org_slug: z.string().trim().min(1),
    token: z.string().min(1),
    new_password: passwordRules,
    confirm_password: z.string(),
})
    .refine((d) => d.new_password === d.confirm_password, {
    message: 'Passwords do not match',
    path: ['confirm_password'],
});
export const changePasswordSchema = z
    .object({
    current_password: z.string().min(1, 'Current password is required'),
    new_password: passwordRules,
    confirm_password: z.string(),
})
    .refine((d) => d.new_password === d.confirm_password, {
    message: 'Passwords do not match',
    path: ['confirm_password'],
});
export const acceptInvitationSchema = z
    .object({
    org_slug: z.string().trim().min(1),
    token: z.string().min(1),
    password: passwordRules,
    confirm_password: z.string(),
})
    .refine((d) => d.password === d.confirm_password, {
    message: 'Passwords do not match',
    path: ['confirm_password'],
});
//# sourceMappingURL=auth.schemas.js.map